export default function Testimonials() {
  const testimonials = [
    {
      quote: 'Mt Zion Renovation transformed our retail space into a modern, inviting store. Their expertise with commercial buildouts and attention to detail was exceptional.',
      author: 'Sarah Mitchell',
      project: 'Retail Store Buildout',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/9ffeb6b5d16e971fc2ceaef8943e93d4.jpg'
    },
    {
      quote: 'From design to completion, the team exceeded our expectations. Our restaurant renovation was completed on time and looks absolutely stunning.',
      author: 'Michael Chen',
      project: 'Restaurant Renovation',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20asian%20man%20smiling%2C%20natural%20lighting%2C%20clean%20background%2C%20authentic%20expression%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-2&orientation=squarish'
    },
    {
      quote: 'The commercial remodeling project was seamless. They kept us informed every step of the way and delivered exceptional quality work that transformed our office space.',
      author: 'Jennifer Rodriguez',
      project: 'Office Remodeling',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20friendly%20hispanic%20woman%20smiling%2C%20natural%20lighting%2C%20clean%20background%2C%20authentic%20expression%2C%20professional%20headshot%20photography&width=400&height=400&seq=testimonial-3&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-gray-600 tracking-wider uppercase mb-3">CLIENT TESTIMONIALS</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            What Our Clients Say
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-start gap-2 mb-4">
              <span className="text-sm font-semibold text-gray-600 tracking-wider uppercase">FEATURED REVIEW</span>
              <div className="w-1.5 h-1.5 bg-gray-600 rounded-full mt-2"></div>
            </div>
            <div className="text-6xl md:text-7xl font-light text-gray-900 leading-tight mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              "Working with Mt Zion Renovation was the best decision we made for our commercial space."
            </div>
            <div className="flex items-center gap-3 mb-2">
              <span className="text-lg font-semibold text-gray-900">David Thompson</span>
              <div className="flex items-center gap-1 px-3 py-1 bg-green-50 rounded-full">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-sm text-green-600"></i>
                </div>
                <span className="text-xs font-medium text-green-700">Verified on Google</span>
              </div>
            </div>
            <p className="text-sm text-gray-600">Complete Commercial Renovation</p>
          </div>

          <div className="lg:col-span-3">
            <div className="relative h-[500px] w-full rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20businessman%20in%20black%20and%20white%2C%20looking%20slightly%20upward%2C%20shoulders%20up%20composition%2C%20side%20angle%2C%20authentic%20expression%2C%20professional%20photography%2C%20trustworthy%20atmosphere&width=800&height=1000&seq=featured-testimonial&orientation=portrait"
                alt="David Thompson"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-lg text-amber-400"></i>
                  </div>
                ))}
              </div>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.author}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{testimonial.author}</div>
                  <div className="text-xs text-gray-600">{testimonial.project}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
